import { useFormContext, useWatch } from "react-hook-form"
import { FormField, FormItem, FormMessage } from "~/shadcn/ui/form"
import { Select } from "~/ui/Select"
import { SearchValues } from "~/screens/casting/data/searchSchema"
import { categoryOptions } from "~/common/enums"

const FIELD_NAME = "influencerCategories"

export const InfluencerCategoryFilter = () => {
  const form = useFormContext<SearchValues>()

  const selectedCategories =
    useWatch({
      control: form.control,
      name: FIELD_NAME,
    }) || []

  return (
    <div className="flex-1">
      <FormField
        control={form.control}
        name={FIELD_NAME}
        render={({ field }) => (
          <FormItem>
            <Select
              options={categoryOptions}
              value={categoryOptions.filter((option) =>
                selectedCategories.includes(option.value)
              )}
              onChange={(options) => {
                field.onChange(options.map((option) => option.value))
              }}
              placeholder="Categories"
              isMulti
            />
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  )
}
